<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
         
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-if="!saleContacts?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
              <div class="text-gray-700 fs-4 fw-bold">{{ $t('statistics.sale_contacts') }}</div>
            </div>
            <div v-if="saleContacts?.length" class="p-5">
              <h5 style="margin-bottom: 20px; text-align: start">{{ $t('statistics.sale_contacts') }} ({{ defaultCurrency?.symbol }})</h5>
              <canvas id="kt_chartjs_contacts" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import {  onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Loader from '@/components/Loader.vue';
import { watch } from 'vue';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    
})

const saleContacts = ref([])
const chartContactRef = ref(null)

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
       props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date}).then((res) => {
          saleContacts.value = res?.data?.top_customers || res?.response?.data;


        }),  
    ]).then(() => {
      chartContacts()
    }) 
  }
    
}

function chartContacts(){
  let ctx = document.getElementById('kt_chartjs_contacts');

  if (ctx) {
    if(Chart.getChart("kt_chartjs_contacts")) {
      Chart.getChart("kt_chartjs_contacts")?.destroy()
    }
    let context = ctx.getContext('2d');
    let primaryColor = KTUtil.getCssVariableValue('--bs-primary');
    let successColor = KTUtil.getCssVariableValue('--bs-success');

    let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

    let names = [];
    let amounts = [];
    let counts = [];

    saleContacts.value.slice(0, 5).forEach(contact => {
      names.push(contact.name)
      amounts.push(contact.amount)
      counts.push(contact.count)
    })

    let data = {
        labels: names,
        datasets: [{
          label: 'My First Dataset',
          data: amounts,
          backgroundColor: [
            primaryColor,
            'rgba(240, 120, 23, 1)',
            successColor,
            'rgba(75, 192, 192, 1)',
            'rgba(54, 162, 235, 1)'
          ],
          hoverOffset: 4
      }]
    };

    let config = {
        type: 'doughnut',
        data: data,
        options: {
          plugins: {
              legend: {
                  display: true
              },
              tooltip: {
                  callbacks: {
                      label: function(context) {
                          return `${i18n.global.t('statistics.amount')}: ${$formatLocalAmount(context.parsed)} ${defaultCurrency.value?.symbol} (${counts[context.dataIndex]})`;
                      }
                  }
              }
            },
            responsive: true,
            elements: {
            arc: {
                borderWidth: 1 
            }
          },
          cutout: '80%'
        },
        defaults:{
            global: {
                defaultFont: fontFamily
            }
        }
    };

    if (!chartContactRef.value) {
      chartContactRef.value = new Chart(ctx, config);
    }else{
      chartContactRef.value.destroy()
      chartContactRef.value = new Chart(ctx, config);
    }
  } else {
    console.error('Canvas element not found');
  }
}

onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>